import { Component } from '@angular/core';
import { DataserviceService } from '../dataservice.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-payplan-attributes',
  templateUrl: './payplan-attributes.component.html',
  styleUrl: './payplan-attributes.component.css'
})
export class PayplanAttributesComponent {

  providers: any;
  selectedProvider: any;
  attributeModal: boolean = false;
  attributeForm: FormGroup;
  atts: any = [];
  payPlanAttributes: any;

  constructor(
    private data: DataserviceService
  ) {

    this.attributeForm = new FormGroup({
      'provider_id': new FormControl(null, [Validators.required]),
      'attributes': new FormControl(null)
    })

  }

  ngOnInit() {
    this.getProviders();
  }

  getProviders() {
    this.data.getData('providers')
      .subscribe({
        next: (res: any) => {
          console.log('RES: ', res)
          this.providers = res?.data || [];
          // this.providersList = res?.data || [];
          // this.loading = false;
        },
        error: (err: any) => {
          console.log('err from getProviders: ', err)
          // this.errorNotification('Failed to get providers!');
        }
      })
  }

  openModal() {
    this.attributeModal = true;
  }

  closeModal() {
    this.atts = [];
    this.attributeForm.reset();
    this.attributeModal = false;
  }

  addChip() {
    this.atts.push(this.attributeForm.get('attributes')?.value);
    this.attributeForm.get('attributes')?.reset()
  }

  removeChip(chip: any) {
    this.atts = this.atts.filter((c: any) => c !== chip);
  }

  save() {
    if(this.attributeForm.valid && this.atts?.length > 0) {

      let obj = {
        provider_id: this.attributeForm.get('provider_id')?.value,
        attributes: this.atts
      }

      this.data.postData(obj, `payplan-attributes/save`)
        .subscribe({
          next: (res: any) => {
            console.log('res on saving attribute: ', res)
          },
          error: (err: any) => {
            console.log('error on saving attribute: ', err)
          }
        })
    }else {
      alert('Select a provider and at least one payplan attribute value')
    }
  }
 
}
